function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { storeBrandDelete, storeBrandList, storeBrandSave, storeBrandToggle, storeBrandUpdate } from '@/api/distributionStore';
var emptyForm = function emptyForm() {
  return {
    id: null,
    name: '',
    icon: '',
    sort: 0,
    isShow: 1
  };
};
export default {
  name: 'DistributionStoreBrand',
  data: function data() {
    return {
      loading: false,
      saving: false,
      visible: false,
      rows: [],
      total: 0,
      query: {
        page: 1,
        limit: 20,
        keywords: ''
      },
      form: emptyForm(),
      rules: {
        name: [{
          required: true,
          message: '请输入品牌名称',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var res;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return storeBrandList(this.query);
            case 2:
              res = _context.v;
              this.rows = res.list || [];
              this.total = res.total || 0;
            case 3:
              _context.p = 3;
              this.loading = false;
              return _context.f(3);
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 3, 4]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    pageChange: function pageChange(page) {
      this.query.page = page;
      this.load();
    },
    open: function open(row) {
      this.form = row ? {
        id: row.id,
        name: row.name,
        icon: row.icon || '',
        sort: row.sort || 0,
        isShow: row.isShow
      } : emptyForm();
      this.visible = true;
    },
    submit: function submit() {
      var _this = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this.saving = true;
                _context2.p = 2;
                _context2.n = 3;
                return _this.form.id ? storeBrandUpdate(_this.form) : storeBrandSave(_this.form);
              case 3:
                _this.$message.success('保存成功');
                _this.visible = false;
                _this.load();
              case 4:
                _context2.p = 4;
                _this.saving = false;
                return _context2.f(4);
              case 5:
                return _context2.a(2);
            }
          }, _callee2, null, [[2,, 4, 5]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    toggle: function () {
      var _toggle = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return storeBrandToggle(row.id);
            case 1:
              this.$message.success('状态已更新');
              this.load();
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toggle(_x2) {
        return _toggle.apply(this, arguments);
      }
      return toggle;
    }(),
    remove: function remove(row) {
      var _this2 = this;
      this.$confirm("\u786E\u5B9A\u5220\u9664\u54C1\u724C\u201C".concat(row.name, "\u201D\u5417\uFF1F"), '提示', {
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return storeBrandDelete(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.load();
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      })));
    }
  }
};